import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../index";
import { api } from "@/lib";

@Module({ name: "company", dynamic: true, store: Store, namespaced: true, stateFactory: true })
export default class CompanyModule extends VuexModule {
  public loading: boolean = false;
  public error: boolean = false;
  public errorMessage: string = "";

  @Action
  async createCompany(payload) {
    return await api.postAsync("/companies", payload);
  }

  @Action
  async searchCompanies(search) {
    let searchParams = "page=1&pageSize=200";
    if (search.deliveryForId != undefined && search.deliveryForId != null) {
      searchParams += `&deliveryForId=${search.deliveryForId}`;
    } else {
      searchParams += ``;
    }
    if (search.companyName) {
      searchParams += `&name=${encodeURIComponent(search.companyName)}`;
    }
    if (search.id) {
      searchParams += `&id=${encodeURIComponent(search.id)}`;
    }
    if (search.address) {
      searchParams += `&address1=${encodeURIComponent(search.address)}`;
    }
    if (search.phoneNumber) {
      searchParams += `&phoneNumber=${encodeURIComponent(search.phoneNumber)}`;
    }
    if (search.includeBillTos) {
      searchParams += "&includeBillToCompanies=true";
    }
    if (search.sort) {
      searchParams += `&sortField=${search.sort}`;
    }
    if (search.excludeRestrictedNewOrderBillTos) {
      searchParams += "&excludeRestrictedNewOrderBillTos=true";
    }
    return await api.getAsync(`/companies?${searchParams}`);
  }

  @Action
  async searchCompaniesTypeAhead(search) {
    let searchParams = "page=1&pageSize=200";
    if (search.typeAheadValue) {
      searchParams += `&typeAheadValue=${encodeURIComponent(search.typeAheadValue)}`;
    }
    if (search.deliveryForId>0) {
      searchParams += `&deliveryForId=${search.deliveryForId}`;
    }
    if (search.includeBillTos) {
      searchParams += "&includeBillToCompanies=true";
    }
    if (search.sort) {
      searchParams += `&sortField=${search.sort}`;
    }
    if (search.excludeRestrictedNewOrderBillTos) {
      searchParams += "&excludeRestrictedNewOrderBillTos=true";
    }
    return await api.getAsync(`/companies/typeAhead?${searchParams}`);
  }

  @Action
  async createCompanyContact(payload) {
    return await api.postAsync(`/companies/${payload.companyId}/contacts`, payload);
  }

  @Action
  async updateCompanyContact(payload) {
    return await api
      .putAsync(`/companies/${payload.companyId}/contacts/${payload.id}`, payload)
      .then(response => {
        this.context.dispatch(
          "order/getOrderConsigneeContacts",
          this.context.rootState.order.currentOrder.number,
          {
            root: true
          }
        );
        return response.data;
      })
      .catch(err => {
        console.log(err);
      });
  }

  @Action
  async getCompanyContacts(companyId) {
    return await api.getAsync(`/companies/${companyId}/contacts`);
  }

  @Action
  async getCompanyById(obj) {
    let {companyId, deliveryForId} = obj;
    return await api.getAsync(`/companies/${companyId}?deliveryForId=${deliveryForId}`);
  }
}
